import { Action, createReducer, createSelector, on } from '@ngrx/store';
import { Comment, User } from 'lingo2-models';
import { sortBy } from 'lodash-es';
import { AppState } from '..';
import { loadComment, loadCommentsSuccess, loadCommentSuccess, removeComment } from '../actions/comment.actions';
import { ILoadableCollection, insertIntoCollection, removeFromCollection } from '../models';
import { getMe } from './profile.reducer';
import { getUsers } from './users.reducer';

export interface State {
  comments: ILoadableCollection<Comment>;
}

const initialState: State = {
  comments: {},
};

const commentReducer = createReducer(
  initialState,
  on(loadComment, (state, { comment_id }) => {
    let comment = {
      data: null,
      loaded: false,
      loading: false,
    };
    if (state.comments[comment_id]) {
      comment = { ...state.comments[comment_id] };
    }
    comment.loading = true;
    return {
      ...state,
      comments: {
        ...state.comments,
        [comment_id]: comment,
      },
    };
  }),
  on(loadCommentSuccess, (state, { comment }) => ({
    ...state,
    comments: insertIntoCollection([comment], { ...state.comments }),
  })),
  on(loadCommentsSuccess, (state, { comments }) => ({
    ...state,
    comments: insertIntoCollection(comments, { ...state.comments }),
  })),
  on(removeComment, (state, { comment_id }) => ({
    ...state,
    comments: removeFromCollection(comment_id, { ...state.comments }),
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return commentReducer(state, action);
}

const thisFeatureKey = 'comments';
export const commentFeatureKey = thisFeatureKey;

// export const getComment = (state: AppState): IUserCollection => state[thisFeatureKey].users;
const getThisState = (state: AppState) => state[thisFeatureKey] as State;
const getComments = (state: AppState) => getThisState(state).comments;
export const getThreadDigest = (props: { thread_id: string }) =>
  createSelector(getMe, getUsers, getComments, (me, users, stateComments) => {
    const comments = sortBy(
      Object.values(stateComments).filter((comment) => comment.loaded && comment.data?.thread_id === props.thread_id),
      'data.created_at',
    ).reverse();
    const is_commented = comments.some((comment) => comment.data?.author_id === me.id);
    const comments_count = comments.length;
    const first: Comment[] = comments.map((comment) => ({
      ...comment.data,
      author: new User(users[comment.data.author_id]),
    }));
    return {
      comments_count,
      is_commented,
      first,
    };
  });
